'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentDwollaAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M35.7943 39.0098C35.319 39.593 34.9631 40.2638 34.7258 41.0221C34.4879 41.7809 34.3696 42.5789 34.3696 43.4164C34.3696 44.2544 34.4882 45.0527 34.7258 45.811C34.9631 46.5692 35.3193 47.237 35.7943 47.8146C36.2692 48.3921 36.8655 48.8536 37.584 49.1986C38.3014 49.5439 39.1356 49.7164 40.0856 49.7164C41.0355 49.7164 41.8666 49.5439 42.5789 49.1986C43.2912 48.8536 43.8847 48.3921 44.3597 47.8146C44.8347 47.2373 45.1908 46.5692 45.4284 45.811C45.6658 45.053 45.7846 44.2544 45.7846 43.4164C45.7846 42.5789 45.6658 41.7809 45.4284 41.0221C45.1908 40.2638 44.8349 39.593 44.3597 39.0098C43.885 38.4268 43.2915 37.9629 42.5789 37.617C41.8666 37.272 41.0355 37.0992 40.0856 37.0992C39.1356 37.0992 38.3017 37.272 37.584 37.617C36.8655 37.9629 36.2692 38.4268 35.7943 39.0098ZM17.0434 38.9077C16.1103 37.9172 14.7223 37.3994 12.879 37.3543H8.68966V49.4791H12.879C14.7223 49.4337 16.1103 48.9159 17.0434 47.9251C17.9764 46.9348 18.4426 45.4318 18.4426 43.4164C18.4426 41.4015 17.9764 39.8988 17.0434 38.9077ZM14.55 48.2137C13.9222 48.4006 13.173 48.4939 12.3027 48.4939H9.84286V38.3389H12.3027C13.173 38.3389 13.9222 38.4325 14.55 38.6191C15.1773 38.806 15.6951 39.1028 16.1019 39.5104C16.5087 39.9183 16.8083 40.4445 17.0009 41.09C17.1929 41.7353 17.2889 42.511 17.2889 43.4164C17.2889 44.3224 17.1929 45.0978 17.0009 45.743C16.8083 46.3883 16.509 46.9148 16.1019 47.3224C15.6951 47.73 15.1773 48.0271 14.55 48.2137ZM19.9858 37.3543L22.7337 47.9679H22.7677L25.7189 37.3543H27.1604L30.1287 47.9679H30.1628L32.9276 37.3543H34.0808L30.7394 49.4791H29.5181L26.4481 38.6278H26.414L23.361 49.4791H22.1058L18.7476 37.3543H19.9858ZM35.7858 45.3608C35.9609 46.0007 36.2323 46.5723 36.6 47.076C36.9672 47.58 37.4393 47.9848 38.0162 48.2907C38.5931 48.5959 39.2826 48.749 40.0856 48.749C40.8885 48.749 41.5755 48.5959 42.1465 48.2907C42.7172 47.9851 43.1868 47.5803 43.5539 47.076C43.9219 46.5723 44.193 46.0007 44.3687 45.3608C44.5429 44.7274 44.6312 44.0734 44.6311 43.4164C44.6311 42.7483 44.5438 42.0978 44.3687 41.4638C44.1933 40.8299 43.9219 40.261 43.5539 39.757C43.1868 39.2536 42.7172 38.8485 42.1465 38.543C41.5755 38.2371 40.8885 38.0846 40.0856 38.0846C39.2826 38.0846 38.5931 38.2371 38.0162 38.543C37.4393 38.8485 36.9672 39.2536 36.6 39.757C36.2323 40.261 35.9609 40.8299 35.7858 41.4638C35.6101 42.0997 35.5216 42.7566 35.5229 43.4164C35.5229 44.0732 35.6101 44.7215 35.7858 45.3608ZM48.3962 48.4939V37.3543H47.243V49.4791H55.1809V48.4939H48.3962ZM57.5045 37.3543V48.4939H64.1928L68.6652 37.3543H69.9547L74.7035 49.4791H73.4652L71.9894 45.7092H66.477L65.0183 49.4791H64.2891H63.7973H56.3513V37.3543H57.5045ZM71.5994 44.724L69.259 38.5089L66.8335 44.724H71.5994Z",
          fill: "#2D2D48"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M42.5083 7.43901L51.6889 12.7457C52.125 12.9977 52.3936 13.4637 52.3933 13.9679V24.5813C52.3934 25.0855 52.1247 25.5514 51.6886 25.8035L42.508 31.1102C42.0719 31.3622 41.5347 31.3622 41.0986 31.1102L31.9179 25.8035C31.4818 25.5515 31.2132 25.0855 31.2132 24.5813V13.9679C31.2132 13.4637 31.4818 12.9978 31.9179 12.7457L41.0988 7.43901C41.5349 7.187 42.0722 7.187 42.5083 7.43901ZM35.785 22.7535V16.6212C35.785 16.117 36.0538 15.6511 36.49 15.399L41.8035 12.3277V8.66124L32.6229 13.9679V24.5813L35.785 22.7535ZM41.0986 18.0524C40.6624 18.3045 40.3938 18.7704 40.3939 19.2746V25.3855L37.1947 27.2346V16.6213L46.3753 11.3146V15.0024L41.0986 18.0524ZM41.8035 29.8879L50.9839 24.5813L50.9842 13.9679L41.8035 19.2746V29.8879Z",
          fill: "url(#paint0_linear_647_1928)"
        }
      ),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint0_linear_647_1928",
          x1: 40.7853,
          y1: 40.6043,
          x2: 63.102,
          y2: 23.2742,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#F3904A" }),
            /* @__PURE__ */ jsx("stop", { offset: 0.999, stopColor: "#AA437F" })
          ]
        }
      ) })
    ]
  }
);
const VpPaymentDwollaAsset = forwardRef(PaymentDwollaAsset);

export { VpPaymentDwollaAsset as default };
